import PropTypes from 'prop-types';

export default {
  children: PropTypes.node,
  style: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/uikit/PropTypes.js